import { datadogRum } from '@datadog/browser-rum'
import { consoleLogger } from '.'

type DataDogRumContext = Record<string, unknown>

export class DataDogRumLogger {
  /**
   * Check if Datadog RUM is initialized by attempting to get internal context.
   * This method runs at call time, so it works even if RUM initialized after instantiation.
   */
  private isDataDogRumInitialized(): boolean {
    try {
      const ctx = datadogRum.getInternalContext()
      return Boolean(ctx?.application_id)
    } catch {
      return false
    }
  }

  /**
   * Logs an error to Datadog RUM.
   * @param error - The error object or string to log
   * @param context - Optional additional metadata
   */
  error(error: Error | string, context?: DataDogRumContext) {
    if (!this.isDataDogRumInitialized()) {
      consoleLogger.info('DataDog RUM not initialized — skipping error log.')
      return
    }

    datadogRum.addError(error, context)
  }
}
